module.exports = __webpack_public_path__ + "img/guotai.1657d2a4.jpeg";